import { HowDoPlansWorkModalProps } from '../../types/components/shared/HowDoPlansWorkModal';

import { Dialog } from '@headlessui/react';
import DetectOutsideClick from '../helpers/DetectOutsideClick';

import { HOW_DO_PLANS_WORK_VIDEO_URL } from '../../constants/ui';

const HowDoPlansWorkModal: React.FC<HowDoPlansWorkModalProps> = ({
  isOpen,
  setIsOpen,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="relative z-40"
    >
      <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
      <div className="fixed inset-0" cy-test-id="how-do-plans-work-modal">
        <div className="flex items-center justify-center min-h-full p-4">
          <DetectOutsideClick onOutsideClick={() => setIsOpen(false)}>
            <iframe
              key={isOpen ? 'modal-open' : 'modal-closed'}
              className="max-w-full max-h-full w-auto h-auto md:w-[768px] md:h-[432px]"
              src={HOW_DO_PLANS_WORK_VIDEO_URL}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </DetectOutsideClick>
        </div>
      </div>
    </Dialog>
  )
}

export default HowDoPlansWorkModal;
